import { IconContext } from '@phosphor-icons/react';
import classNames from 'classnames';
import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import styles from './IconButton.module.scss';

export type TIconButtonSize = 'xs' | 'sm' | 'md' | 'lg';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'clear' | 'accent' | 'tertiary' | 'outline' | 'secondary' | 'secondary-accent' | 'full';
  size?: TIconButtonSize;
  ref?: Ref<HTMLButtonElement>;
  active?: boolean;
  children: ReactNode;
  title?: string;
  iconWeight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
}

const ICON_BUTTON_ICON_SIZE = { xs: 14, sm: 14, md: 16, lg: 16 } as const;

export function IconButton(props: IconButtonProps) {
  'use memo';

  const {
    variant = 'clear',
    size = 'md',
    active,
    className,
    children,
    title,
    iconWeight = 'bold',
    ref,
    ...rest
  } = props;

  const resolvedIconSize = ICON_BUTTON_ICON_SIZE[size];

  return (
    <button
      type="button"
      ref={ref}
      className={classNames(styles.iconButton, styles[variant], styles[size], { [styles.active]: active }, className)}
      aria-label={title}
      {...rest}
    >
      <IconContext.Provider value={{ weight: iconWeight, size: resolvedIconSize }}>{children}</IconContext.Provider>
    </button>
  );
}
